// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__HS6Ie","resendInfoText":"OnGoingPaymentBox_resendInfoText__zfMVa"};